import React, { useState, useEffect } from "react";
import { Search } from "@mui/icons-material";
import CalendorIcon from "../../../src/assests/images/calendar-2.svg";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  Box,
  Link,
  Typography,
  TextField,
  InputAdornment,
} from "@mui/material";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ActivityDataTable from "./ActivityDataTable";
import { debounce } from "lodash";
import arrowLeft from "../../../src/assests/images/arrow-left.svg";
import arrowRight from "../../../src/assests/images/arrow-right.png";
import doubleArrowLeft from "../../../src/assests/images/double-arrow-left.svg";
import doubleArrowRight from "../../../src/assests/images/double-arrow-right.svg";
import { useLocation, useNavigate } from "react-router-dom";

function ActivityLog() {
  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([
    null,
    null,
  ]);
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  const [startDate, endDate] = dateRange;

  // Debounce the search query
  useEffect(() => {
    const handleDebounce = debounce((query) => setDebouncedSearch(query), 300);
    handleDebounce(searchQuery);
    return () => handleDebounce.cancel();
  }, [searchQuery]);
  console.log(searchQuery, "search query");

  const formatDate = (date: Date) =>
    date.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });

  const location = useLocation();
  const navigate = useNavigate();

  const handleGoBack = () => {
    if (location.state?.previousPath) {
      navigate(location.state.previousPath);
    } else {
      navigate(-1); // fallback to browser history
    }
  };

  return (
    <Box sx={{ background: "#fff", paddingTop: "30px" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "0 32px",
        }}
      >
        <Box>
          <Box sx={{ display: "flex" }}>
            <Link
              href="/ProfileSetting"
              sx={{
                textDecoration: "none",
                fontSize: "14px",
                fontWeight: "500",
                color: "rgba(105, 106, 107, 1)",
                paddingRight: "10px",
              }}
            >
              Profile
            </Link>{" "}
            /
            <Typography
              sx={{
                textDecoration: "none",
                fontSize: "14px",
                fontWeight: "600",
                color: "#8E020F",
                paddingLeft: "10px",
              }}
            >
              Activity Log
            </Typography>
          </Box>
          <Typography
            variant="h3"
            sx={{
              fontSize: "24px",
              fontWeight: "600",
              color: "#000",
              marginTop: "16px",
            }}
          >
            Activity Log
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "16px",
          padding: "0 32px 30px",
        }}
      >
        <Box sx={{ maxWidth: "520px", flexGrow: 1 }}>
          <TextField
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="Search by Type"
            type="search"
            variant="outlined"
            size="small"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search sx={{ height: "20px", width: "20px" }} />
                </InputAdornment>
              ),
            }}
            sx={{
              width: "100%",

              "& input": {
                padding: "12.5px 14px 12.5px 0",
              },
              "& .MuiOutlinedInput-root": {
                paddingTop: "0", paddingBottom: "0",
                borderRadius: "12px",
                "& fieldset": {
                  border: "2px solid #F5F5F5",
                },
                "&:hover fieldset": {
                  border: "2px solid #F5F5F5", // prevent border change on hover
                  outline: "none"
                },
              },

            }}
          />
        </Box>
        <Box sx={{ display: "flex" }}>
          <DatePicker
            selectsRange
            startDate={startDate || undefined}
            endDate={endDate || undefined}
            onChange={(update: [Date | null, Date | null]) => {
              const [start, end] = update;
              setDateRange([start, end]);
            }}
            placeholderText="Select Date Range"
            renderCustomHeader={({
              date,
              changeYear,
              changeMonth,
              decreaseMonth,
              increaseMonth,
              prevMonthButtonDisabled,
              nextMonthButtonDisabled,
            }) => (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "8px",
                  marginBottom: "10px",
                }}
              >
                {/* Previous Year */}
                <button onClick={() => changeYear(date.getFullYear() - 1)} >
                  <img src={doubleArrowLeft} alt="double left arrow" />
                </button>

                {/* Previous Month */}
                <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
                  <img src={arrowLeft} alt="left arrow" />
                </button>

                {/* Month and Year Label */}
                <span style={{ fontWeight: 600 }}>
                  {date.toLocaleString("default", { month: "short" })} {date.getFullYear()}
                </span>

                {/* Next Month */}
                <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
                  <img src={arrowRight} alt="right arrow" />
                </button>

                {/* Next Year */}
                <button onClick={() => changeYear(date.getFullYear() + 1)}>
                  <img src={doubleArrowRight} alt="double right arrow" />
                </button>
              </div>
            )}
            customInput={
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  border: "1px solid #ccc",
                  backgroundColor: "#fff",
                  borderRadius: "10px",
                  padding: "0 10px",
                  height: "48px",
                  width: "300px",
                  position: "relative",
                }}
              >
                <input
                  style={{
                    fontSize: "14px",
                    border: "none",
                    outline: "none",
                    flex: 1,
                    backgroundColor: "transparent",
                  }}
                  placeholder="Select Date Range"
                  value={
                    startDate && endDate
                      ? `${formatDate(startDate)} to ${formatDate(endDate)}`
                      : startDate
                        ? `${formatDate(startDate)} to`
                        : ""
                  }
                  readOnly
                />

                {(startDate || endDate) && (
                  <span
                    style={{
                      cursor: "pointer",
                      marginRight: "8px",
                      fontSize: "16px",
                      color: "#888",
                      fontWeight: "bold",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setDateRange([null, null]);
                    }}
                  >
                    ×
                  </span>
                )}

                <img
                  src={CalendorIcon}
                  alt="Calendar Icon"
                  style={{
                    height: "20px",
                    width: "20px",
                    cursor: "pointer",
                  }}
                />
              </div>
            }
          />


        </Box>
      </Box>
      <Box>
        <ActivityDataTable
          startDate={startDate}
          endDate={endDate}
          searchQuery={debouncedSearch} // Pass debounced search query
        />
      </Box>
      <Box
        sx={{
          position: "fixed",
          bottom: "0",
          background: "#fff",
          height: "80px",
          width: "84%",
          padding: "10px 30px",
          marginTop: "40px",
          borderTop: "1px solid #E7E8E9"
        }}
      >
        <Link
          href="#"
          onClick={handleGoBack}
          sx={{
            textDecoration: "none",
            fontSize: "14px",
            fontWeight: "500",
            color: "#C8172F",
            display: "flex",
            alignItems: "center",
            marginTop: "20px"
          }}
        >
          <ArrowBackIcon sx={{ fontSize: "16px", marginRight: "5px" }} />
          Back
        </Link>
      </Box>
    </Box>
  );
}

export default ActivityLog;
